// Guided-Flow Constants
export const GUIDED_FLOW_BANK_ACCOUNTS = "Bank accounts";
export const GUIDED_FLOW_RETIREMENT_ACCOUNTS_OR_ANNUITIES = "Retirement accounts and annuities";
export const GUIDED_FLOW_INVESTMENT = "Investments";
export const GUIDED_FLOW_REAL_ESTATE = "Real estate";
export const GUIDED_FLOW_PERSONAL_PROPERTY = "Personal property";
export const GUIDED_FLOW_RECEIVABLE = "Receivables";
export const GUIDED_FLOW_LIABILITIES = "Liabilities";
export const GUIDED_FLOW_TRUST = "Trust";
export const GUIDED_FLOW_OTHER = "Other"; // Guided-Flow Constants

export const GUIDED_FLOW_ADD_BANK_ACCOUNT = "a bank account";
export const GUIDED_FLOW_ADD_RETIREMENT_ACCOUNT_OR_ANNUITY = "a retirement account or annuity";
export const GUIDED_FLOW_ADD_INVESTMENT_ACCOUNT = "investment account";
export const GUIDED_FLOW_ADD_REAL_ESTATE = "real estate";
export const GUIDED_FLOW_ADD_PERSONAL_PROPERTY = "personal property";
export const GUIDED_FLOW_ADD_RECEIVABLE = "a receivable";
export const GUIDED_FLOW_ADD_LIABILITY = "liability";
export const GUIDED_FLOW_ADD_TRUST = "a trust";
export const GUIDED_FLOW_ADD_OTHER = "other"; // other content will probably change once we know what constitutes as "other"?
export const GUIDED_FLOW_ADD_PREFIX = "Add ";
export const GUIDED_FLOW_EDIT_PREFIX = "Edit ";
